export default {"src":"/frontend-static/_next/static/media/logo-google.d8ace6f6.svg","height":17,"width":49,"blurWidth":0,"blurHeight":0};